// extracted by mini-css-extract-plugin
export default {"root":"CurrencySwitcher_root__pFP5n","option":"CurrencySwitcher_option__Uhwbr","optionActive":"CurrencySwitcher_optionActive__KfbG3","compact":"CurrencySwitcher_compact__wtAJS"};